import { info } from './info';

export const channels = {
  info,
};
